// src/utils/ptsEditMode.js

let activeEditors = 0;

export function enterPtsEdit() {
  activeEditors += 1;

  if (activeEditors === 1) {
    document.body.classList.add("pts-edit-mode");
  }
}

export function exitPtsEdit() {
  activeEditors -= 1;

  if (activeEditors <= 0) {
    activeEditors = 0;
    document.body.classList.remove("pts-edit-mode");
  }
}

export function resetPtsEdit() {
  activeEditors = 0;
  document.body.classList.remove("pts-edit-mode");
}
